import { Root } from "./Root";

export const INITIAL_VALUES: Root = {
	rootId: 0,
	rootName: "",
	rootTypeId: 0,
	isActive: true,
	locationId: 0,
	rootStateId: 0,
	stateComments: "",
	needsAttention: true,
	attentionComments: "",
	supervisorInstructions: "",
	workerComments: "",
};
